/* eslint-disable nordic/i18n-jsx-no-literals */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
const React = require('react');
const Copy20 = require('@andes/icons/Copy20');
const Dropdown = require('@andes/dropdown');
const CopyToClipboard = require('react-copy-to-clipboard');
const Modal = require('@andes/modal');

const { DropdownStandalone, DropdownItem } = Dropdown;

const ModalSnippet = ({ showModal, codeContent, codeLanguage, type, title, setShowModal, copyAction, deviceType, notCode, lang, setCodeType, languageOptions }) => {
  return (
    <Modal
      open={showModal}
      onClose={() => { setShowModal(false); }}
      closable
      closeButtonSrLabel=""
      maxWidth={0}
      srLabel=""
      title={title}
      type={deviceType === 'mobile' ? 'full' : 'large'}
      className="api-ref-modal-component"
    >
      <div className="actions">

        {type === 'request' && (
          <div className="api-dropdown-language">
            <DropdownStandalone
              defaultOpen={false}
              defaultValue={codeLanguage}
              onChange={(event, value) => { setCodeType(value); }}
              menuAlignment="bottom"
              menuMaxHeight={500}
              id="dropdown-id"
              label=""
              srLabel=""
            >
              {languageOptions.map(option => (
                <DropdownItem
                  title={option.title}
                  value={option.value}
                />
              ))}
            </DropdownStandalone>
          </div>
        )}

        <div>
          <CopyToClipboard
            onCopy={() => {
              copyAction();
            }}
          >
            <div className="api-copy">
              <Copy20 color="rgba(0, 0, 0, 0.55)" />
            </div>
          </CopyToClipboard>
        </div>

      </div>
      <div className="api-ref-modal">
        <div className={`code_editor--${type}`} language={codeLanguage}>
          {codeContent !== '{}' ? (
            <pre className={`code-container--${type} api-ref-scrool language-${codeLanguage} line-numbers`}>
              <code>
                {codeContent}
              </code>
            </pre>
          ) : (
              <div className="not-code">
                {notCode?.description?.[lang]}
              </div>
            )}
        </div>
      </div>
    </Modal>
  );
};

module.exports = ModalSnippet;
